import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
import apt from './assets/apt.png'
import blood from './assets/Bld.jpg'
import stce from './assets/stce.jfif'
import amzn from './assets/amzn.jpg'
import ggle from './assets/ggle.jpg'
import mcrsft from './assets/mcrsft.jpg' 
import Dshaw from './assets/DEshaw.png'
import Yahoo from './assets/yahoo.jpg'
import acc from './assets/acc.png'
import gs from './assets/gs.jpg'
import mmt from './assets/mmt.png'
import flpkrt from './assets/flpkrt.png'
import Pytm from './assets/Pytm.png'
import ola from './assets/ola.jfif'
import csco from './assets/csco.jfif'
import samsung from './assets/samsung.png'
import qual from './assets/qual.png'
import snap from './assets/snap.jpg'
import sap from './assets/sap.png'

const Iq = () => {
    return (
        <div>
            <h1 className='container' style={{textAlign:'center'}}>Interview Preparation</h1>
            <div></div>
            <h1  className='container'>Logical Question (important for each company)</h1>
              <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
   <div class="card 1">
    <div class="card_image"> <img src={apt}/> </div>
    <div class="card_title title-white">
      <p>Aptitude question</p>
      <NavLink to='/category/Interview question/1'>
        <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
   </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={blood} />
      </div>
    <div class="card_title title-white">
      <p>Blood Relation</p>
      <NavLink to='/category/br'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={stce} />
    </div>
    <div class="card_title">
        <p>Sentence Rearrange</p>
        <NavLink to='/category/Order'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
  
   
    </div>
    <h1  className='container'>Company Wise Preparation</h1>
          <div class="cards-list"data-aos="fade-right" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={amzn} /> </div>
    <div class="card_title title-white">
      <p>Amazon</p>
      <NavLink to='/category/Amazon'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={ggle} />
      </div>
    <div class="card_title title-white">
      <p>Google</p>
      <NavLink to='/category/Google'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={mcrsft} />
    </div>
    <div class="card_title">
        <p>Microsoft</p>
        <NavLink to='/category/Microsoft'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={Dshaw} />
      </div>
    <div class="card_title title-black">
      <p>D E Shaw</p>
      <NavLink to='/category/DE-Shaw'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
    <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  <div class="card 3">
    <div class="card_image"> <img src={Yahoo} /> </div>
    <div class="card_title title-white">
      <p>&nbsp;</p>
      <NavLink to='/category/Yahoo'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={acc} />
      </div>
    <div class="card_title title-white">
      <p>Accolite</p>
      <NavLink to='/category/Accolite'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={gs} />
    </div>
    <div class="card_title">
        <p>Goldman Sachs</p>
        <NavLink to='/category/Goldman-Sachs'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={mmt} />
      </div>
    <div class="card_title title-black">
      <p>Make my trip</p>
      <NavLink to='/category/Make-My-Trip'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
    </div>
    <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  <div class="card 3">
    <div class="card_image"> <img src={flpkrt} /> </div>
    <div class="card_title title-white">
      <p>Flipkart</p>
      <NavLink to='/category/Flipkart'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={Pytm} />
      </div>
    <div class="card_title title-white">
      <p>Paytm</p>
      <NavLink to='/category/Paytm'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={ola} />
    </div>
    <div class="card_title">
        <p style={{color:'white'}}>Ola Cabs</p>
        <NavLink to='/category/Ola'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={csco} />
      </div>
    <div class="card_title title-black">
      <p>Cisco</p>
      <NavLink to='/category/Cisco'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   </div>
   <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  <div class="card 3">
    <div class="card_image"> <img src={samsung} /> </div>
    <div class="card_title title-white">
      <p>Samsung</p>
      <NavLink to='/category/Samsung'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={qual} />
      </div>
    <div class="card_title title-white">
      <p>Qualcomm</p>
      <NavLink to='/category/Qualcomm'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={snap} />
    </div>
    <div class="card_title">
        <p>Snapdeal</p>
        <NavLink to='/category/Snapdeal'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    

   </div>
  
    </div>
    


        </div>
    )
}

export default Iq
